if (process.env.NODE_ENV !== 'production') {
    // 引入vsconle
    const script = document.createElement('script')
    script.src = 'https://wechat-qiniu.yaduo.com/js/lib/vconsole.min.js'
    script.onload = () => {
        /* eslint-disable */
        new VConsole()
    }
    document.body.appendChild(script)
}

import axios from 'axios'
import axiosConfig from '@/config/config'
function wxShare (shareUrl, title, desc, imgUrl) {
    console.log(shareUrl, title, desc, imgUrl)
    axios.get(axiosConfig.WXSHARE).then(rel => {
        let cofigData = rel.data.result
        console.log('cofigData', cofigData)
        const config = {
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: cofigData.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
            timestamp: cofigData.timeStamp, // 必填，生成签名的时间戳
            nonceStr: cofigData.nonceStr, // 必填，生成签名的随机串
            signature: cofigData.signature, // 必填，签名，见附录1
            jsApiList: [
                'updateAppMessageShareData',
                'updateTimelineShareData'
            ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        } // startRecord开始录音接口，startRecord识别音频并返回识别结果接口，stopRecord停止录音接口，playVoice播放语音接口
        loadSdkJS().then(() => {
            console.log('loadedSDK')
            window.wx.config(config)
            window.wx.ready(() => {
                console.log('分享ready')
                window.wx.updateAppMessageShareData({
                    title: title, // 分享标题
                    desc: desc, // 分享描述
                    link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: imgUrl, // 分享图标
                    success () {
                    }
                })
                window.wx.updateTimelineShareData({
                    title: title, // 分享标题
                    link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: imgUrl, // 分享图标
                    success () {
                    }
                })
            })
        })
    })
}
const navigator = window.navigator

function loadSdkJS() {
    const agent = navigator.userAgent.toLowerCase()
    let sdkUrl = ''
    if (agent.indexOf('micromessenger') !== -1) { // 微信环境
        sdkUrl = 'https://res2.wx.qq.com/open/js/jweixin-1.6.0.js'
    } else if (agent.indexOf('alipayclient') > -1) { // 支付宝环境
        sdkUrl = 'https://appx/web-view.min.js'
    }
    console.log('sdkUrl===>', sdkUrl)
    return new Promise((resolve, reject) => {
        if ((window.wx && window.wx.miniProgram) || window.my) {
            resolve()
        }
        if (sdkUrl) {
            const script = document.createElement('script')
            script.src = sdkUrl
            script.onload = () => {
                // 加载sdk完成后
                resolve()
            }
            document.body.appendChild(script)
        } else {
            resolve()
        }

    })
}

function isMiniApp (resolve, reject) {
    const agent = navigator.userAgent.toLowerCase()
    if (agent.indexOf('micromessenger') > -1 || agent.indexOf('wechatdevtools') > -1) {
        console.log(wx)
        wx && wx.miniProgram.getEnv((res) => {
            if (res.miniprogram) {
                console.log('微信小程序')
                resolve({
                    body: wx,
                    type: 'wechat'
                })
            } else {
                console.log('微信小程序1')
                reject()
            }
        })
    } else if (agent.indexOf('alipayclient') > -1) {
        my && my.getEnv((res) => {
            if (res.miniprogram) {
                console.log('支付宝小程序')
                resolve({
                    body: my,
                    type: 'alipay'
                })
            } else {
                console.log('支付宝小程序1')
                reject()
            }
        })
    } else {
        console.log('不在小程序')
        reject()
    }
}
const ua = window.navigator.userAgent.toLowerCase()
function isBoole(s) {
  let valid = false
  if (window.navigator.userAgent) {
    if (s && Array.isArray(s)) {
      s.forEach(agent => {
        if (ua.indexOf(agent.toLowerCase(), 0) !== -1) {
          valid = true
        }
      })
    } else if (s && ua.indexOf(s.toLowerCase(), 0) !== -1) {
      valid = true
    }
  }
  return valid
}
function isApp ()  {
  return isBoole(['atourbrowser', 'atourOMS', 'atourJML'])
}


export function judgeMiniApp () {
    return new Promise((resolve, reject) => {
        if ((window.wx && window.wx.miniProgram) || window.my) {
            isMiniApp(resolve, reject)
        } else {
            loadSdkJS().then(() => {
                isMiniApp(resolve, reject)
            })
        }
    })
}

function goToIndex(token) {
    if (Prius && Prius.isInsideApp) {
        Prius.backpage({})
    } else {
        judgeMiniApp().then(({ body, type }) => {
            console.log('是小程序')
            if (type === 'alipay') {
                body.switchTab({
                    url: '/pages/index/index'
                })
            } else {
                body.miniProgram.switchTab({
                    url: '/pages/index/index'
                })
            }
        }).catch(() => {
            if (process.env.NODE_ENV === 'development') {
                window.location.href = window.location.protocol + '//qa0-wechat.at-our.com'
            } else {
                window.location.href = axiosConfig.wechatUrl + (token ? `?token=${token}` : '')
            }
        })
    }
}
// 微信分享跳转会员法宝页面
function goMebers(token) {
    if (Prius && Prius.isInsideApp) {
        Prius.backpage({})
    } else {
        const org = `${axiosConfig.wechatUrl}`
        judgeMiniApp().then(({ body, type }) => {
            if (type === 'alipay') {
                const _url = 'hy/memberItems?isNeedToken=1'
                window.wx.miniProgram.navigateTo({
                    url: '/pages/NewWebView/NewWebView?url=' + encodeURIComponent(_url)
                })
            } else {
                body.miniProgram.navigateTo({
                    url: `/pages/WebView/WebView?url=https://wechat.yaduo.com/hy/memberItems?isNeedToken=1`
                })
            }
        }).catch(() => {
            if (process.env.NODE_ENV === 'development') {
                window.location.href = window.location.protocol + `//qa0-wechat.at-our.com/hy/memberItems?isNeedToken=1${token ? '&token=' + token : ''}`
            } else {
                // window.location.href = 'https://wechat.yaduo.com/hy/memberItems?isNeedToken=1'
                window.location.href = org + (token ? `hy/memberItems?isNeedToken=1&token=${token}` : `hy/memberItems`)
            }
        })
    }
}
// ops 活动扩展配置
function goActiveConfiguration(buttonUrlType, token) {
    if (Prius && Prius.isInsideApp) {
        console.log('是APP', buttonUrlType)
        const org = `${axiosConfig.wechatUrl}`
        if (buttonUrlType === 1) {
            Prius.appEventCallback({event: 'PAGE_HOME',data: {}})
        } else if (buttonUrlType === 2) {
            Prius.appEventCallback({event: 'USERCOUPONS',data: ({couponType: 0, sortScene: 2})})
        } else {
            window.location.href = org + (token ? `hy/memberItems?isNeedToken=1&token=${token}` : `hy/memberItems?isNeedToken=1`)  // 会员法宝页面
        }
    } else {
        judgeMiniApp().then(({ body, type }) => {
            console.log('是小程序')
            if (type === 'alipay') {
                body.miniProgram.navigateTo({
                    url: '/pages/CouponsPackage/CouponsPackage'
                })
            } else {
                // 支付宝小程序
                body.miniProgram.navigateTo({
                    url: '/pages/WebView/WebView?url=https://wechat.yaduo.com/atour/coupon'
                })
            }
        }).catch(() => {
            if (process.env.NODE_ENV === 'development') {
                window.location.href = window.location.protocol + '//qa0-wechat.at-our.com/atour/coupon'
            } else {
                window.location.href = axiosConfig.wechatUrl + 'atour/coupon'
            }
        })
    }
}

function getQueryVal(name) {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
    const r = window.location.search.substr(1).match(reg);
    let rel = '';
    if (r != null) {
        rel = r[2] || '';
    }
    return rel;
}
export function getUrlQueryObj(url = '', params = {}) {
  let res = '';
  for(let key in params) {
    res += `${key}=${params[key]}&`;
  }
  return `${url}?${res}`;
}
export function getUrlParams(url, decode = true) {
  const obj = {};
  const search = decode ? decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ') : url.split('?')[1];
  if (!search) {
      return obj;
  }
  const searchArr = search.split('&');
  searchArr.forEach(v => {
      const index = v.indexOf('=');
      if (index !== -1) {
          const name = v.substring(0, index);
          const val = v.substring(index + 1, v.length);
          obj[name] = val;
      }
  });
  return obj;
}

export const getAppVer = () => {
  // 如果在app中则取ua中的版本号
  if (isApp()) {
      const ua = window.navigator.userAgent.toLocaleLowerCase();
      const version = ua.match(/atourbrowser-atourlife\/([.\d]+)/)[1];
      return version;
  }
  if (getQueryVal('version')) { // 如果URL中携带版本号则使用url上的版本
      return getQueryVal('version');
  }
  // 最后选择本地的版本
  return window.localStorage.getItem('version') || '3.0.0';
};


export { goToIndex, wxShare, goActiveConfiguration, goMebers, getQueryVal }



// WEBPACK FOOTER //
// ./src/assets/js/utils.js